import { useState } from 'react';

/** A per-device preference (kitchen view, station…), kept in localStorage when available. */
export function usePref<T extends string>(key: string, initial: T): [T, (v: T) => void] {
  const [v, setV] = useState<T>(() => {
    try { return (localStorage.getItem(`fm.pref.${key}`) as T | null) ?? initial; } catch { return initial; }
  });
  return [v, (next: T) => { setV(next); try { localStorage.setItem(`fm.pref.${key}`, next); } catch { /* ignore */ } }];
}
